import { IconSeekers } from 'ui-seeker/core'
import { useState, useRef, useEffect } from 'react'
import * as React from 'react'
import AdminSectionPanel from './Panel'


export default function BottomNavAdminSection() {

    const [isOpen, setIsOpen] = useState(false)
    const triggerRef = useRef(null)

    useEffect(() => {
        if (!isOpen) return
        const handle = (e) => {
            const panel = document.querySelector('.sidenav > .navigation')
            if (
                triggerRef.current && !triggerRef.current.contains(e.target) &&
                (!panel || !panel.contains(e.target))
            ) {
                setIsOpen(false)
            }
        }
        document.addEventListener('mousedown', handle)
        return () => document.removeEventListener('mousedown', handle)
    }, [isOpen])

    return <>
        <div ref={triggerRef} className="toolItem" onClick={() => setIsOpen(prev => !prev)}>
            <span className="toolIcon">
                <IconSeekers icon="cog" iconType="fontAwesome" />
            </span>
        </div>
        <AdminSectionPanel isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
}
